import { createGlobalStyle } from 'styled-components'
import type { LngLatBoundsLike } from 'react-map-gl/maplibre'

import { breakpoints } from '@/styles'

export const mapZIndex = {
  dotMarker: 1,
  labelMarker: 2,
  sponsoredMarker: 3,
  poiMarker: 4,
  hoveredMarker: 5,
  updateControls: 8,
  markerPopup: 9,
  filters: 11
}

export const markerCounts = {
  // desktop:
  max_markers: 250,
  max_sponsored_labels: 15,
  max_total_labels: 20,
  // mobile:
  max_markers_mobile: 100,
  max_sponsored_labels_mobile: 10,
  max_total_labels_mobile: 15
}

export const zoomLevels = {
  max: 18,
  default: 11,
  defaultHood: 13,
  labelsOnAllMarkers: 14.5
}

export const defaultCoords = [49.256253658122446, -123.12404038633632]

export const CANADA_BOUNDS = {
  topLeft: {
    lat: 72.1559413589888,
    lon: -126.88818661043646
  },
  bottomRight: {
    lat: 35.32016689712147,
    lon: -71.78076473543706
  }
}

// Canada bounds for map viewport
export const CANADA_BOUNDS_ARRAY = [
  [CANADA_BOUNDS.topLeft.lon, CANADA_BOUNDS.bottomRight.lat],
  [CANADA_BOUNDS.bottomRight.lon, CANADA_BOUNDS.topLeft.lat]
] as LngLatBoundsLike

// Global styles for the map page
export const GlobalStyles = createGlobalStyle`
 .maplibregl-ctrl-bottom-right .maplibregl-ctrl {
    margin: 0 20px 20px 0;
  }
  .maplibregl-popup {
    z-index: ${mapZIndex.markerPopup};
  }
  .maplibregl-marker:hover {
    z-index: ${mapZIndex.hoveredMarker} !important;
  }
  .maplibregl-ctrl-group:not(:empty) {
    box-shadow: 0px 2px 1px 0px rgba(0, 0, 0, 0.05), 0px 0px 1px 0px rgba(0, 0, 0, 0.25);
  }

  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    body, html {
      overflow: hidden;
      position: fixed;
      width: 100%;
    }
    .maplibregl-ctrl-group {
      display: none;
    }
  }
`
